import { Component, OnInit, Input, Output, EventEmitter, ViewChild, SimpleChange, ElementRef, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { Detail, DetailPropertyGroup, DetailProperty, DetailSection, Action, ValueSelection, CombinationProperty, PropertyValidation } from '../objects/DetailObject';
import { DetailService } from '../services/detail.service';
import { DatePipe, KeyValuePipe } from '@angular/common';
import { NgForm, ControlContainer, NgModel } from '@angular/forms';
import { DateFormatService } from '../services/date-format.service';
import { AmazingTimePickerService } from 'amazing-time-picker';
import { KeyValue } from '@angular/common';
import { SummaryService } from '../services/summary.service';
import { ToasterMessageService } from '../services/toaster-message.service';
import { Router } from '@angular/router';
import { ModalControlService } from '../services/modal-control.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource, MatRadioButton, MatCheckbox } from '@angular/material';
import { of, Observable, Subscription } from 'rxjs';
import { ThemeSettingService } from '../services/theme-setting.service';
import { ThemeSetting } from '../objects/ThemeObject';
import { NgSelectComponent } from '@ng-select/ng-select';
import { PdfJsViewerComponent } from 'ng2-pdfjs-viewer';
import { WorkflowReturnService } from '../services/workflow-return.service';
import { WorkspaceService } from '../services/workspace.service';
import { Globals } from '../objects/Globals';
import { NgxMaterialTimepickerTheme, NgxTimepickerFieldComponent } from 'ngx-material-timepicker';

@Component({
  selector: 'app-property-controls',
  templateUrl: './property-controls.component.html',
  styleUrls: ['./property-controls.component.css'],
  viewProviders: [ 
    { provide: ControlContainer, useExisting: NgForm } ]
})

export class PropertyControlsComponent implements OnInit, AfterViewInit , OnDestroy{

  private editorConfig = new Object();
  property: DetailProperty;
  private ngForm: NgForm;
  private dateValue: Date;
  private timeValue: string = "00:00";
  private defaultTime: string = "00:00";
  private retrievingLookupList:boolean = false;
  private showCheckbox:boolean = false;
  private invalid:any;
  private groupCheckbox:any = [];
  private originalGroupCheckbox: any = [];
  private inputLabel:boolean = false;
  private combinationProperties:CombinationProperty[] = [];
  private componentId: string;
  private loaderConfig: ThemeSetting;
  private showChart: boolean = false;
  
  private sub1: Subscription;
  private sub2: Subscription;
  private sub3: Subscription;
  private sub4: Subscription;
  private sub5: Subscription;

  // tagArray = [];
  noValidate: boolean = false;
  focus: boolean = false;
  format24h: boolean = true;
  dateMax: any;
  dateMin: any;

  darkTheme: NgxMaterialTimepickerTheme = {
    container: {
      buttonColor: 'var(--primary)'
    },
    dial: {
      dialBackgroundColor: 'var(--primary)',
    },
    clockFace: {
      clockFaceBackgroundColor: 'var(--primary)',
      clockHandColor: '#FFF',
      clockFaceTimeInactiveColor: '#FFF',
      clockFaceTimeActiveColor: 'var(--primary)'
    }
};

  @ViewChild('textbox') textbox:ElementRef;
  @ViewChild('textarea') textarea:ElementRef;
  @ViewChild('select') select:NgSelectComponent;
  @ViewChild('matRadio') matRadio: MatRadioButton;
  @ViewChild('matCheckbox') matCheckbox: MatCheckbox;
  @ViewChild('cb') checkbox: ElementRef;
  @ViewChild('pdfViewer') public pdfViewer: PdfJsViewerComponent;
  @ViewChild('timepicker') timepicker: NgxTimepickerFieldComponent;

  @Input() set setProperty(obj:any) {
    var prop: DetailProperty = obj.property;
    this.componentId = obj.id;
    if (prop.PropertyFormControlType.toUpperCase() == "DATE"){
      if (prop.PropertyValue){
        this.dateValue = new Date(prop.PropertyValue);
      }
      else{
        this.dateValue = null;
      }
      
      this.dateFormatService.setFormat(prop.PropertyDisplayFormat.toUpperCase());

      this.handleMinMaxDate(prop);
    }
    else if (prop.PropertyFormControlType.toUpperCase() == "DATETIME"){
      var date = new Date(prop.PropertyValue);
      if(date.getHours()){
        var hour = date.getHours().toString();
        var minute = date.getMinutes().toString();
        if (date.getHours() < 10){
          hour = "0" + date.getHours().toString();
        }
        if (date.getMinutes() < 10){
          minute = "0" + date.getMinutes().toString();
        }
        this.timeValue = hour + ":" + minute;
        this.defaultTime = this.timeValue;
      }

      this.dateValue = new Date(date);
      this.detailService.getDateTimePropertyDateSegmentValue(this.componentId, prop.PropertyName).subscribe(result => {
        if (prop.PropertyDisplayFormat.indexOf("tt") > -1){
          this.format24h = false;
          var merd = date.getHours() > 11 ? "pm" : "am";
          this.defaultTime = this.defaultTime + merd;
        }
        
        prop.PropertyDisplayFormat = result;

        this.dateFormatService.setFormat(result.toUpperCase());

        if (prop.PropertyValue) {
          this.dateValue = new Date(date);
        }else{
          this.dateValue = null;
        }
        
      });
      
      this.handleMinMaxDate(prop);
    }
    else if (prop.PropertyFormControlType.toUpperCase() == "COMBOBOX"){
      if (!prop.PropertyValueSelection){
        prop.PropertyValue = "";
        prop.PropertyValueDisplay = "";
      }
      else{
        if (prop.PropertyValueSelection.filter(x => x.SelectionValue.toLowerCase() == prop.PropertyValue.toLowerCase()).length == 0){
          prop.PropertyValue = "";
          prop.PropertyValueDisplay = "";
        }
      }
      prop.IsDropdownOpen = false;
    }
    else if (prop.PropertyFormControlType.toUpperCase() == "MULTICOMBOBOX" || prop.PropertyFormControlType.toUpperCase() == "HIERARCHYMULTISELECT" || prop.PropertyFormControlType.toUpperCase() == "HIERARCHYSINGLESELECT"){
      prop.IsDropdownOpen = false;
      if (prop.PropertyValueSelection){
        prop.PropertyValueSelection.forEach(element => {
          element.SelectionMapValue = element.SelectionValue;
        });
      }
      else{
        prop.PropertyValueArray = [];
        prop.PropertyValueDisplayArray = [];
      }
      
      if (prop.PropertyValueArray){
        prop.PropertyValueArray.forEach((item, index) => {
          if (prop.PropertyValueSelection.filter(x => x.SelectionValue.toLowerCase() == item.toLowerCase()).length == 0){
            prop.PropertyValueArray.splice(index, 1);
            prop.PropertyValueDisplayArray.splice(index, 1);
          }
        });
      }
    }
    else if (prop.PropertyFormControlType.toUpperCase() == "TEXTBOXSUGGEST" || prop.PropertyFormControlType.toUpperCase() == "TEXTBOXSUGGESTID"){
      this.onClickCombobox(prop);
    }

    this.property = prop;
  }

  @Input() set updateProperty(property: DetailProperty){
    if (property){
      if (this.property.PropertyId == property.PropertyId){
        // var array = [];
        // property.PropertyValueArray.forEach(element => {
        //   array.push(element);
        // });
        // //this.property.PropertyValueArray = array; // just angular things !
        var prop = Object.assign({}, property);
        this.property = prop;
        this.property.PropertyValueSelection = [].concat(prop.PropertyValueSelection); // remember angular/ng-select use onPush detection strategy
        this.property.PropertyValueArray = [].concat(prop.PropertyValueArray); 

        var array:any = property.PropertyValueArray;
        if (property.PropertyFormControlType.toUpperCase() == "HIERARCHYSINGLESELECT"){
          if (property.PropertyValueArray.length > 0){
            array = property.PropertyValueArray[0];
          }
        }
        this.updateField(property, array);
      }
    }
  }

  @Input() group:DetailPropertyGroup;
  @Input() set combinationProperty(combProperty:CombinationProperty[]){
    this.combinationProperties = combProperty;
    if(this.combinationProperties.length > 0){
      this.combinationProperties.forEach(property => {
        if (property.properties){
          if (property.properties.filter(x => !x.PropertyIsEditable).length == 1){
            property.IsInputLabel = true;
          }
        }
      });
    }
  }
  @Input() detailObject:Detail;
  @Input() fixedMessageList:Object;
  @Input() submitted:boolean;
  @Input() isPopupDetail:boolean;
  @Input() currentLookup:string;
  @Input() set detailForm(form:NgForm){
    this.ngForm = form;
  };
  @Output() showLoading = new EventEmitter<boolean>();
  @Output() reloadDetail = new EventEmitter<string>();
  @Output() childControl = new EventEmitter<NgModel>();
  @Output() updateForm = new EventEmitter<DetailProperty>();
  @Output() setCurrentLookup = new EventEmitter<string>();
  @Output() updateHierarchy = new EventEmitter<DetailProperty>();
  @Output() showHierarchy = new EventEmitter<boolean>();
  @Output() selectedItem = new EventEmitter<string>();
  @Output() propertyValueChanged = new EventEmitter<string>();
  @Output() countdownEnd = new EventEmitter<string>();

  @ViewChild('textbox') control: NgModel;
  constructor(
    private detailService:DetailService, 
    private dateFormatService:DateFormatService, 
    private atp: AmazingTimePickerService, 
    private keyValuePipe:KeyValuePipe, 
    private toasterMessageService:ToasterMessageService,
    private router: Router,
    private modalControlService: ModalControlService,
    private modalService:BsModalService,
    private themeSettingService: ThemeSettingService,
    private cd: ChangeDetectorRef,
    private workflowReturnService: WorkflowReturnService,
    private workspaceService: WorkspaceService,
    private summaryService: SummaryService,
    public globals: Globals) {

    this.sub1 = this.detailService.currentPropertyFocusChanged$.subscribe(result => {
      if (this.property.PropertyId == result){
        if (this.textbox){
          this.textbox.nativeElement.focus();
        }
        else if (this.textarea){
          this.textarea.nativeElement.focus();
        }
        else if (this.select){
          this.select.focus();
        }
        else if (this.matRadio){
          this.matRadio.focus();
        }
        else if (this.matCheckbox){
          this.matCheckbox.focus();
        }
      }
      else {
        if (this.property){
          if (this.property.PropertyFormControlType.toUpperCase() == "COMBINATION"){
            var combineProperties = [];

            this.combinationProperties.map(x => x.properties).forEach(element => {
              combineProperties = combineProperties.concat(element);
            });
  
            var prop = combineProperties.find(x => x.PropertyId == result);
            if (prop){
              if (prop.PropertyFormControlType.toUpperCase() == "TEXTBOX" || prop.PropertyFormControlType.toUpperCase() == "DATE"){
                this.textbox.nativeElement.focus();
              }
              else if (prop.PropertyFormControlType.toUpperCase() == "COMBOBOX" || prop.PropertyFormControlType.toUpperCase() == "MULTICOMBOBOX"){
                this.select.focus();
              }
            }
          }
        }
      }
    });

    this.sub2 = this.detailService.currentLookupChanged$.subscribe(lookup => {
      this.currentLookup = lookup;
    });

    this.sub3 = this.detailService.parentChildChanged$.subscribe((prop:DetailProperty) => {
      if (prop){
        if (this.property.PropertyName == prop.ChildPropertyName){
          this.property.PropertyValue = "";
          this.property.PropertyValueDisplay = "";
          this.property.isDisabled = true;
          setTimeout(() => {
            this.onValueChange(this.property, "");
          })
          
        }
      }
    });

    this.sub4 = this.detailService.disableChild$.subscribe((prop:any) => {
      if (prop){
        if (this.property.PropertyName == prop.property.ChildPropertyName){
          this.property.isDisabled = prop.isDisable;
        }
      }
    });

    this.sub5 = this.summaryService.chartTableChanged$.subscribe(loading => {
      if (loading){
        this.showChart = true;
      }
    });
  }

  afterInit(){
    this.timepicker.registerOnChange(this.onChangeTime.bind(this));
  }

  ngOnInit() {
    this.loaderConfig = this.themeSettingService.getTheme();
    
  }

  ngOnDestroy(){
    if (this.sub1) this.sub1.unsubscribe();
    if (this.sub2) this.sub2.unsubscribe();
    if (this.sub3) this.sub3.unsubscribe();
    if (this.sub4) this.sub4.unsubscribe();
    if (this.sub5) this.sub5.unsubscribe();
  }

  ngAfterViewInit(){
    this.textareaAutoHeight();
    if (this.pdfViewer){
      this.pdfViewer.refresh();
    }
  }

  textareaAutoHeight(){
    if (this.textarea){
      setTimeout(() => {
        var height = this.textarea.nativeElement.scrollHeight;
        this.textarea.nativeElement.setAttribute('style', 'height:' + (height) + 'px;');  
      })
      
      this.textarea.nativeElement.addEventListener("input", OnInput, false);
    }
    function OnInput() {
      this.style.height = 'auto';
      this.style.height = (this.scrollHeight + 5) + 'px';
    }
  }

  handleMinMaxDate(prop: DetailProperty){
    if (prop.PropertyValidation){
      if (prop.PropertyValidation.MinValue == "@CURRENTDATETIME"){
        this.dateMin = new Date();
      }
      else{
        if (prop.PropertyValidation.MinValue){
          this.dateMin = new Date(prop.PropertyValidation.MinValue);
        }
      }
      
      if (prop.PropertyValidation.MaxValue == "@CURRENTDATETIME"){
        this.dateMax = new Date();
      }
      else{
        if (prop.PropertyValidation.MinValue){
          this.dateMax = new Date(prop.PropertyValidation.MaxValue);
        }
      }
    }
  }

  onChangeTime(time: string){
    if (time){
        if (this.dateValue){
            var hour = +time.split(':')[0];
            var minute = +time.split(':')[1];
            if (time.indexOf("pm") > -1 || time.indexOf("am") > -1){
                time = this.convertTime12to24(time);
                var hour = +time.split(':')[0];
                var minute = +time.split(':')[1];
            }

            this.timeValue = hour + ":" + minute;

            this.dateValue.setHours(hour, minute);
            var value:any = this.dateValue;

            this.handleCustomMinMaxDatetime(this.property, value);

            this.updateField(this.property, value);
        }
    }
  }

  convertTime12to24(time12h){ //format ex: 10:10 am/ 12:12pm
    const [time, modifier] = time12h.split(' ');
  
    let [hours, minutes] = time.split(':');
  
    if (hours == '12') {
      hours = '00';
    }
    
    if (modifier){
      if (modifier.toLowerCase() == 'pm') {
        hours = parseInt(hours, 10) + 12;
      }
    }
    
  
    return `${hours}:${minutes}`;
  }
  

  openTimePicker(property: DetailProperty) {
    const timePicker = this.atp.open({
      time:  this.timeValue,
      arrowStyle: {
          background: this.loaderConfig.primaryColour,
          color: '#FFF'
      }
    });
    
    timePicker.afterClose().subscribe(time => {
      this.onTimeChange(time, property);
    });
  }

  handleCustomMinMaxDatetime(property: DetailProperty, value: any, isUpdate: boolean = false){
    if (isNaN(Date.parse(value)) == false){
      this.handleMinMaxDate(property);
      if (this.dateMin < value){
        setTimeout(() => {
          if (this.ngForm.controls[property.PropertyName].errors){
            if (this.ngForm.controls[property.PropertyName].errors.length == 1){
              if (this.ngForm.controls[property.PropertyName].errors.DateMin){
                this.ngForm.controls[property.PropertyName].setErrors(null);
              }
            }
            else{
              if (this.ngForm.controls[property.PropertyName].errors.length > 0){
                this.ngForm.controls[property.PropertyName].setErrors({'DateMin': null});
              }
            }
          }
        }, 500); // angular ng on change
      }
      else if (this.dateMin > value){
        setTimeout(() => {
          this.ngForm.controls[property.PropertyName].markAsDirty();
          this.ngForm.controls[property.PropertyName].setErrors({DateMin: true});
        }, 500); // angular ng on change
      }
    }
  }

  onTimeChange(time:any, property: DetailProperty){
    if (time){
      this.timeValue = time;
      if (this.dateValue){
        this.dateValue.setHours(+this.timeValue.split(':')[0], +this.timeValue.split(':')[1]);
        var value:any = this.dateValue;
        
        this.handleCustomMinMaxDatetime(property, value);
  
        this.updateField(this.property, value);
      }
    }
  }

  onDateTimeChange(input: string, date:any, ngModel: any, property: DetailProperty){
    if (ngModel){
      var isUpdate: boolean = false;
      var timestamp = Date.parse(input);
      
      if (isNaN(timestamp) == false) {
        isUpdate = true;
      }
      else {
        this.dateValue = null;
      }

      if (isUpdate){
        this.dateValue = new Date(input);
        if (this.dateValue){
          this.dateValue.setHours(+this.timeValue.split(':')[0], +this.timeValue.split(':')[1]);

          this.updateField(this.property, this.dateValue);
        }
      }

      this.handleCustomMinMaxDatetime(property, this.dateValue, isUpdate);
      
    }
    else{
      var timestamp = Date.parse(input);
      if (isNaN(timestamp) == false){
        this.dateValue = new Date(input);
        if (this.dateValue){
          this.dateValue.setHours(+this.timeValue.split(':')[0], +this.timeValue.split(':')[1]);

          this.updateField(this.property, this.dateValue);
        }
      }
      else{
        this.dateValue = null;
      }
    }
  }

  setDateValue(value: string){
    this.dateValue = new Date(value);
    if (this.dateValue){
      this.dateValue.setHours(+this.timeValue.split(':')[0], +this.timeValue.split(':')[1]);
    }
  }

  dateChange(prop: DetailProperty, input:string, $event:NgModel){
      var valid = true;
      setTimeout(() => {
        if ($event) {
          valid = $event.valid;
        }
        if (valid){
          var timestamp = Date.parse(input);
          if (isNaN(timestamp) == false){
            this.dateValue = new Date(input);
            this.dateValue.setHours(+this.timeValue.split(':')[0], +this.timeValue.split(':')[1]);

            this.updateField(prop, this.dateValue);
  
            this.handleCustomMinMaxDatetime(prop, this.dateValue);
          }
          else {
            if (!this.property.PropertyValidation) this.property.PropertyValidation = new PropertyValidation();
            if (!input){
              this.dateValue = null;
              this.updateField(prop, this.dateValue);
              this.property.PropertyValidation.InvalidFormat = false;
            }
            else {
              this.property.PropertyValidation.InvalidFormat = true;
            }
          }
          this.updateField(prop, this.dateValue);
        }
        else{
          // ng model has error
          if ($event.errors.matDatepickerMin || $event.errors.matDatepickerMax){
            //min max date error
            this.property.PropertyValidation.InvalidFormat = false;
            this.dateValue = new Date(input);
          }
        }
      })
      
  }

  onTextboxSuggest(property:DetailProperty, event: any){
    if (event){
      this.onValueChange(property, event.item.SelectionValue);
    }
  }

  onValueChange(property: DetailProperty, value:any, $event:any = null){
    if (property.PropertyFormControlType.toUpperCase() == "COMBOBOX"){
      this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId).IsDropdownOpen = false;
    }
    var valid = true;
    if($event){
      setTimeout(() => { // wait one tick for angular ngonchanges to finish
        valid = $event.valid;
        if ($event.errors){
          if ($event.errors.required && value){ // for chrome autocomplete
            valid = true;
          }
        }
        else{
          if (property.PropertyValidation){
            if (property.PropertyValidation.MinMaxType == "NUMBER"){
              if (property.PropertyValidation.MinValue){
                var minValue = property.PropertyValidation.MinValue;
                if (minValue == "@CURRENTYEAR") minValue = new Date().getFullYear().toString();

                if (parseInt(value) < parseInt(minValue)){
                  setTimeout(() => this.ngForm.controls[property.PropertyName].setErrors({pattern: true}));
                }
              }
      
              if (property.PropertyValidation.MaxValue){
                var maxValue = property.PropertyValidation.MaxValue;
                if (maxValue == "@CURRENTYEAR") maxValue = new Date().getFullYear().toString();

                if (parseInt(value) > parseInt(maxValue)){
                  setTimeout(() => this.ngForm.controls[property.PropertyName].setErrors({pattern: true}));
                }
              }
            }
          }
        }
        this.handleValuePassed(property, value, valid);
      })
    }
    else {
      this.handleValuePassed(property, value, valid);
    }
    
  }  

  handleValuePassed(property: DetailProperty, value: any, valid:boolean){
    var newValue: any;
    var selectionValue: string;
    if (property.PropertyFormControlType.toUpperCase() == "TEXTBOX" && property.PropertyDisplayFormat.toUpperCase() == "UPPER"){
      value = value.toUpperCase();
    }

    if (property.PropertyFormControlType.toUpperCase() == "CHECKBOX"){
      this.property.PropertyValueSelection.find(x => x.SelectionValue == value.source.value).IsSelected = value.checked;
      selectionValue = this.property.PropertyValueSelection.find(x => x.SelectionValue == value.source.value).SelectionValue;
      let result = this.property.PropertyValueSelection.filter(x => x.IsSelected).map(a => a.SelectionValue);
      this.property.PropertyValueArray = result;
      newValue = result;
    }
    else if(property.PropertyFormControlType.toUpperCase() == "COMBOBOX"){
      if (property.ChildPropertyName){
        this.detailService.clearChild(property);
        this.detailService.setDisableChild({property:property, isDisable: true});
      }
      if (property.PropertyValidation && value){
        valid = true;
      }
      newValue = value;
    }
    else if (property.PropertyFormControlType.toUpperCase() == "MULTITEXT"){
      newValue = [];
      value.forEach(element => {
        if(element.label){
          newValue.push(element.label);
        }
        else{
          newValue.push(element);
        }
      });
    }
    else if(property.PropertyFormControlType.toUpperCase() == "MULTICOMBOBOX") {
      newValue = [];
      value.forEach(x => {
        if (x.GroupBy && !x.SelectionMapValue){
          var list = property.PropertyValueSelection.filter(g => g.GroupBy == x.GroupBy);
          list.forEach(element => {
            newValue.push(element.SelectionMapValue);
          });
        }
        else {
          newValue.push(x.SelectionMapValue);
        }
      });
    }
    else if (property.PropertyFormControlType.toUpperCase() == "HIERARCHYSINGLESELECT"){
      if (property.PropertyValueArray.length > 0){
        newValue = property.PropertyValueArray[0];

        property.PropertyValueSelection.forEach(element => {
            if (newValue) {
                if (element.SelectionValue.toLowerCase() == newValue.toLowerCase()) {
                    element.IsSelected = !element.IsSelected;
                }
                else {
                    element.IsSelected = false;
                }
            }
            else {
                element.IsSelected = false;
            }
          });
      }
      else{
        property.PropertyValueSelection.forEach(x => {
          x.IsSelected = false;
        })
      }
      
      this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId).PropertyValueArray = property.PropertyValueArray;
      this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId).PropertyValueSelection = property.PropertyValueSelection;
      
      var newProp = Object.assign({}, this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId));

      this.updateHierarchy.emit(newProp);
    }
    else if (property.PropertyFormControlType.toUpperCase() == "HIERARCHYMULTISELECT"){
      newValue = [];
      value.forEach(x => {
        newValue.push(x.SelectionValue);
      });

      var array = [];
      property.PropertyValueSelection.forEach(element => {
        if (newValue.indexOf(element.SelectionValue) > -1){
          element.IsSelected = true;
        }
        else{
          element.IsSelected = false;
        }
        array.push(element);
      });

      this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId).PropertyValueArray = newValue;
      this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId).PropertyValueSelection = array;
      // let copy = JSON.parse(JSON.stringify(this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId))); // just angular things !
      
      var newProp = Object.assign({}, this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId));

      this.updateHierarchy.emit(newProp);
    }
    else if (property.PropertyFormControlType.toUpperCase() == "DATE"){
      var timestamp = Date.parse(value);
      if (isNaN(timestamp) == false){
        valid = true;
        this.dateValue = new Date(value);
        newValue = this.dateValue;
      }
      else {
        if (value){
          valid = false;
          newValue = value;
          if (!this.property.PropertyValidation) this.property.PropertyValidation = new PropertyValidation();
          
          if (!value){
            this.property.PropertyValidation.InvalidFormat = false;
          }
          else {
            this.property.PropertyValidation.InvalidFormat = true;
          }
        }
        else{
          // empty string
          valid = true;
          newValue = value;
        }
        
      }
    }
    else{
      newValue = value;
    }

    if (valid){
      this.updateField(property, newValue, selectionValue);
    }
  }
  
  search(property: DetailProperty, $event:KeyboardEvent){
    if(this.currentLookup != property.PropertyName){
      this.onClickCombobox(property, property.PropertyFormControlType.toUpperCase() == 'COMBOBOX' ? true : false);
    }
    else{
      this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId).IsDropdownOpen = true;
      if ($event.keyCode == 13 && property.PropertyFormControlType.toUpperCase() == 'COMBOBOX'){
        this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId).IsDropdownOpen = false;
      }
    }
  }

  updateField(prop:DetailProperty, value:any, selectionValue: string = ""){
    var property = this.property;
    var selection: string;
    selection = selectionValue;
    if(prop){
      property = prop;
    }
    if (property.TriggersWorkflow){
      this.showLoading.emit(true);
    }

    if (prop.PropertyFormControlType.toUpperCase() == "TEXTBOX" || prop.PropertyFormControlType.toUpperCase() == "PASSWORD" || prop.PropertyFormControlType.toUpperCase() == "SECURETEXTBOX" ){
      if (this.ngForm){
        if (prop.ParentPropertyName){
          if (this.ngForm.control.get(prop.ParentPropertyName)){
            if (value != this.ngForm.control.get(prop.ParentPropertyName).value){
              // wait one tick, otherwise angular change will override
              setTimeout(() => this.ngForm.controls[prop.PropertyName].setErrors({noMatch: true}));
            }
            else{
              setTimeout(() => this.ngForm.controls[prop.ParentPropertyName].setErrors(null));
            }
          }
        }
        else if (prop.ChildPropertyName){
          if (this.ngForm.control.get(prop.ChildPropertyName)){
            if (value != this.ngForm.control.get(prop.ChildPropertyName).value){
              // wait one tick, otherwise angular change will override
              setTimeout(() => this.ngForm.controls[prop.PropertyName].setErrors({noMatch: true}));
            }
            else{
              setTimeout(() => this.ngForm.controls[prop.ChildPropertyName].setErrors(null));
            }
          }
        }
      }
    }

     var timestamp = Date.parse(value);
     if (isNaN(timestamp) == false){
       setTimeout(()=> {
         this.dateValue = new Date(value);
       })
     }

    if (this.property.PropertyFormControlType.toUpperCase() == "COMBOBOX"){
      if (this.property.PropertyValueSelection){
        if (this.property.PropertyValueSelection.find(x=> x.SelectionValue.toLowerCase() == value.toLowerCase())){
          this.property.PropertyValueDisplay = this.property.PropertyValueSelection.find(x=> x.SelectionValue.toLowerCase() == value.toLowerCase()).SelectionDisplay;
        }
      }
    }

    this.detailService.pushPendingUpdate(property, value);
    
    this.detailService.updateField(this.componentId, property.PropertyName, value, selection).subscribe(result=> {
      this.detailService.removePendingUpdate(property.PropertyId);
      if (property.ChildPropertyName){
        this.detailService.setDisableChild({property:property, isDisable: false});
      }
      if (result){
        if (result.startsWith("#WF:")){
          this.handleWorkflowReturn(result.substr(4), property);
        }
        else {
          if (property.PropertyFormControlType.toUpperCase() != "TEXTBOXSUGGESTID"){
            property.PropertyValueDisplay = result;
            if (property.PropertyFormControlType.toUpperCase() == "DATE" || property.PropertyFormControlType.toUpperCase() == "DATETIME"){
              this.detailObject.Properties.find(x => x.PropertyName == property.PropertyName).PropertyValue = result;
            }
          }
        }
      }
    });
  }

  handleWorkflowReturn(result, property: DetailProperty){
    var command = JSON.parse(result);
      switch(command.ReturnType){
        case 0: // navigate
          if(command.Arguments){
            var path = [];
            command.Arguments.forEach(element => {
              path.push(element);
            });
            this.router.navigate(path);
          }
          break;
        case 1: //message
          this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
          break;
        case 3:
          this.propertyValueChanged.emit(command.Arguments[0]);
          if (property.TriggersWorkflow){
            this.showLoading.emit(false);
          }
          break;
        case 4:
          this.propertyValueChanged.emit(command.Arguments[0]);
          if (property.TriggersWorkflow){
            this.showLoading.emit(false);
          }
          break;
        case 5:
          this.propertyValueChanged.emit(command.Arguments[0]);
          if (property.TriggersWorkflow){
            this.showLoading.emit(false);
          }
      case 6: // comparison
      case 7: // download file
      case 8: // messagenavigate
      case 9: // chart
      case 10: // go home and navigate
      case 11: // open form
      case 12: // external navigate
      this.workflowReturnService.handleWorkflowReturn(command);
        break;
      }

      if (command.RefreshType){
        switch(command.RefreshType){
          case "self": 
            this.reloadDetail.emit(result);
          break;
          case "parent":
            this.reloadDetail.emit(result);
            this.getEPICParent(false, command.ReturnType, command.IsPreview);
          break;
          case "all":
            this.reloadDetail.emit(result);
            this.getEPICParent(true, command.ReturnType, command.IsPreview);
          break;
        }
      }
      else {
        this.showLoading.emit(false);
      }
  }

  getEPICParent(findAllParent:boolean, returnType:number, isPreview: boolean = false){
    if (findAllParent){
      this.workspaceService.getAllParentsEPICId(this.componentId).subscribe(result => {
        if (result){
          var array = JSON.parse(result);
          array.forEach(id => {
            this.workspaceService.setParentId(id);
          });
        }
      })
    }
    else{
      this.workspaceService.getParentEPICId(this.componentId).subscribe(result => {
        this.workspaceService.setParentId(result);
      })
    }
  }

  getCombinationProperty(propertyId: string):DetailProperty[] {
    if (this.combinationProperties.filter(x => x.IsInputLabel).length > 0){
      this.inputLabel = true;
    }
    else {
      this.inputLabel = false;
    }
    return this.combinationProperties.find(x => x.combinationId == propertyId).properties;
  }

  checkProp(prop){
    console.log(prop);
  }

  checkIfCombinationIsEditable(propertyId: string, prop: DetailProperty){
    // if (this.combinationProperties.find(x => x.combinationId == propertyId).properties.filter(x => x.PropertyIsEditable).length > 0){
    //   return true;
    // }
    // else{
    //   return false;
    // }
    if (!prop) return false
    var propExist = this.combinationProperties.find(x => x.combinationId == propertyId).properties.find(x => x.PropertyId == prop.PropertyId);
    if (propExist){
      if (propExist.PropertyIsEditable && propExist.PropertyFormControlType.toUpperCase() == "LABEL"){
        return true;
      }
      else{
        return false;
      }
    }
    else{
      return false;
    }
  }

  getPropertyWidth(propertyId: string, order: number):any {
    if (order == 0){
      return this.combinationProperties.find(x => x.combinationId == propertyId).columnWidth[0].initialColumnWidth;
    }else{
      return this.combinationProperties.find(x => x.combinationId == propertyId).columnWidth[0].secColumnWidth;
    }
  }
  
  onClickCombobox(property:DetailProperty, isSingle: boolean = false, $event = null){
    if (!property.isDisabled){
      if(this.isPopupDetail){
        document.querySelectorAll("body").item(0).style.position = "relative";
      }
      if ($event){
        if (!$event.target.classList.contains("ng-value-icon")){
          this.showCheckbox = !this.showCheckbox;
        }
      }
      
      if(this.currentLookup != property.PropertyName){
        this.detailService.setLookup(property.PropertyName);
        this.retrievingLookupList = true;
        this.detailService.getLookupList(this.componentId, property.PropertyName).subscribe(result=> {
          var lookupList:ValueSelection[] = JSON.parse(result);
          this.detailObject.Properties.find(x=> x.PropertyName == property.PropertyName).PropertyValueSelection = lookupList;
          this.property.PropertyValueSelection = lookupList;
          this.detailObject.Properties.find(x => x.PropertyName == property.PropertyName).IsDropdownOpen = true;

          // this.detailObject.Properties[this.detailObject.Properties.findIndex(x => x.PropertyName == property)]

          this.retrievingLookupList = false;
          this.detailObject.Properties.find(x => x.PropertyName == property.PropertyName).PropertyValueSelection.forEach(element => {
              element.SelectionMapValue = element.SelectionValue;
          });
          if (this.property.PropertyFormControlType.toUpperCase() == "GROUPCHECKBOX"){
            var grouped = this.groupBy(this.property.PropertyValueSelection, PropertyValueSelection => PropertyValueSelection.GroupBy);
            this.groupCheckbox = this.keyValuePipe.transform(grouped);
            this.originalGroupCheckbox = this.groupCheckbox;
            if (!this.groupCheckbox) this.groupCheckbox = [];

            if (this.property.PropertyValueArray){
              this.property.PropertyValueArray.forEach(value => {
                var valueSelection = this.detailObject.Properties.find(x => x.PropertyName == property.PropertyName).PropertyValueSelection.find(x => x.SelectionValue == value);
                if (valueSelection){
                  valueSelection.IsSelected = true;
                }
              });
            }
          }
        }, error => {
          this.retrievingLookupList = false;
        });
      }
      else{
        if (isSingle){
          this.detailObject.Properties.find(x => x.PropertyName == property.PropertyName).IsDropdownOpen = !this.detailObject.Properties.find(x => x.PropertyName == property.PropertyName).IsDropdownOpen;
        }
        else {
          this.detailObject.Properties.find(x => x.PropertyName == property.PropertyName).IsDropdownOpen = true;
        }      
      }
    }
  }

  onSearch(event){
    this.showCheckbox = true;
    var matchByParent = this.originalGroupCheckbox.filter(x => x.key["name"].toLowerCase().includes(event.term.toLowerCase()));
    if (event.items.length > 0){
      var grouped = this.groupBy(event.items, PropertyValueSelection => PropertyValueSelection.GroupBy);
      var tempCheckbox = this.keyValuePipe.transform(grouped);

      matchByParent.forEach(element => {
        if (tempCheckbox.filter(x => x.key["name"].toLowerCase().includes(element.key["name"].toLowerCase())).length == 0){
          tempCheckbox.push(element);
        }
      });
      this.groupCheckbox = this.sortGroupCheckbox(tempCheckbox);
    }
    else {
      this.groupCheckbox = matchByParent;
    }
  }

  sortGroupCheckbox(data: any){
    return data.sort((a, b) => { 
      if(a.key["name"] > b.key["name"]){
        return 1;
      }else if(a.key["name"] < b.key["name"]){
        return -1;
      }else{
        return 0;
      }
    });
  }

  onBlur(property: DetailProperty){
    this.focus = false;
    this.detailObject.Properties.find(x => x.PropertyName == property.PropertyName).IsDropdownOpen = false;
    // document.querySelectorAll(".overlay-container").item(0).classList.remove("block");
  }

  onCloseCombobox(){
    if(this.isPopupDetail){
      document.querySelectorAll("body").item(0).style.position = "initial";
    }
    // document.querySelectorAll(".overlay-container").item(0).classList.remove("block");
  }

  getNestedChildren(arr, parent) {
    var out = []
    for(var i in arr) {
      if(arr[i].parent == parent) {
        var children = this.getNestedChildren(arr, arr[i].id)

        if(children.length) {
          arr[i].children = children
        }
        out.push(arr[i])
      }
    }
    return out
  }

  toggleHierarchy(property: DetailProperty){
    this.showHierarchy.emit(!this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId).PropertyShowHierarchy);
    // this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId).PropertyShowHierarchy = !this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId).PropertyShowHierarchy;
  }

  onGroupCheckboxChange($event, ngModel:any = null){
    var array = [];
    var groupBy = []

    if ($event.length == 0){
      if(this.groupCheckbox.length > 0){
        this.groupCheckbox.forEach(element => {
          element['key'].isSelected = false;
        });
      }
    }

    $event.forEach(element => {
      array.push(element.SelectionValue);
    });
    
    this.property.PropertyValueArray = array;
    this.property.PropertyValueSelection.forEach(value=> {
      value.IsSelected = false;
    });

    this.property.PropertyValueArray.forEach(value => {
      if (this.property.PropertyValueSelection.find(x => x.SelectionValue == value)){
        this.property.PropertyValueSelection.find(x => x.SelectionValue == value).IsSelected = true;
        groupBy.push(this.property.PropertyValueSelection.find(x => x.SelectionValue == value).GroupBy);
      }
    });

    // probably do this later, check whether theres no child anymore
    // console.log(this.property.PropertyValueSelection);
    // groupBy.forEach(groupId => {
    //   console.log(this.property.PropertyValueSelection.filter(x => x.GroupBy == groupId).filter(x => x.IsSelected));
    //   if (this.property.PropertyValueSelection.filter(x => x.GroupBy == groupId).filter(x => x.IsSelected).length == 0){
    //     console.log(this.groupCheckbox.filter(x => x["key"].name == groupId));
    //   }
    // });

    this.onValueChange(this.property, this.property.PropertyValueArray, ngModel);
  }

  closeCheckbox($event){
    $event.preventDefault();
    $event.stopPropagation();
    this.showCheckbox = false;
  }

  clearAll(){
    this.property.PropertyValueArray = [];
    this.property.PropertyValueSelection.forEach(value=> {
      value.IsSelected = false;
    });

    this.groupCheckbox.forEach(element => {
      element['key'].isSelected = false;
    });
  }

  onSelectedItem(id:string){
    this.selectedItem.emit(id);
  }

  addToPropArray($event:any, selection:any, isParent:boolean, key:any){
    if (isParent){
      selection.forEach(value => {
          this.property.PropertyValueSelection.find(x => x.SelectionValue == value.SelectionValue).IsSelected = !this.property.PropertyValueSelection.find(x => x.SelectionValue == value.SelectionValue).IsSelected;
          this.pushPropertyValue($event, value);
      });
    }
    else {
      this.pushPropertyValue($event, selection);
    }
    this.onValueChange(this.property, this.property.PropertyValueArray);
  }

  groupBy(list, keyGetter) {
    const map = new Map(); // create into map
    var someList = [];
    list.forEach((item) => {
        const key = keyGetter(item);
        var obj = {name: key, isSelected: false}
        if (someList.indexOf(key) >= 0) {
          map.forEach(result => {
            if (result[0].GroupBy == key){
              result.push(item);
            }
          })
        } else {
          map.set(obj, [item]);
        }
        someList.push(key);
    });
    return map;
  }

  compareFn(item, selected){
    return item.SelectionValue.toLowerCase() == selected.toLowerCase();
  }

  // groupBy(list, keyGetter) {
  //   const map = new Map(); // create into map
  //   list.forEach((item) => {
  //       const key = keyGetter(item);
  //       if (!map.has(key)) {
  //         map.set(key, [item]);
  //       } else {
  //         map.get(key).push(item);
  //       }
  //   });
  //   return map;
  // }

  pushPropertyValue($event, value:ValueSelection){
    if ($event.currentTarget.checked){
      if(this.property.PropertyValueArray){
        if (this.property.PropertyValueArray.indexOf(value.SelectionValue) < 0){
          this.property.PropertyValueArray.push(value.SelectionValue);
          this.property.PropertyValueArray = this.property.PropertyValueArray.filter(x => x !== "@*novalue*@");
        }
      }
      else{
        this.property.PropertyValueArray = [];
        this.property.PropertyValueArray.push(value.SelectionValue);
      }
      this.property.PropertyValueSelection.find(x => x.SelectionValue == value.SelectionValue).IsSelected = true;
    }
    else {
      this.property.PropertyValueSelection.find(x => x.SelectionValue == value.SelectionValue).IsSelected = false
      this.property.PropertyValueArray = this.property.PropertyValueArray.filter(x => x !== value.SelectionValue);
    }
  }

  setCountdownEvent(event){
    this.countdownEnd.emit(event);
  }

  optionalChanged(event){
    const checked = event;
    this.noValidate = checked;
    var properties = this.detailObject.Properties.filter(x => x.ParentPropertyName == this.property.PropertyName);
    properties.forEach(prop => {
      prop.PropertyClientIsHidden = !checked;
    });
  }

  setAttachmentValue(value: string){
    this.property.PropertyValue = value;
    this.updateField(this.property, value);
  }

  onPaste(property, e){
    e.stopPropagation();
    e.preventDefault();
    let items = e.clipboardData.getData('Text').split(/\r?\n/).map(item => item.trim());

    property.PropertyValueDisplayArray = items;
    if (items){
      this.updateField(property, items)
    }
  }
}

